import React, { Ref } from 'react';
import { Input } from 'antd';
type TextAreaProps = {
  style: React.CSSProperties;
  inputRef: Ref<HTMLTextAreaElement> | null;
  defaultValue: string;
  key: any;
};
import './textArea.scss';

const { TextArea } = Input;

export const TextAreaNooco = ({ style, inputRef, defaultValue, key }: TextAreaProps) => {
  return (
    <div style={style}>
      <TextArea
        key={key}
        defaultValue={defaultValue}
        className="textfield"
        rows={10}
        ref={inputRef}
      />
    </div>
  );
};
